// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"58a16eda","976":"533d9f7a"}[chunkId] + ".chunk.css";
};